export default "__VITE_PUBLIC_ASSET__bb1a7fb3__"